import { ThemeProvider } from "@mui/material/styles";
import { useTheme as useThemeReact } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { Theme as MaterialTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";
import type {} from "@mui/x-date-pickers-pro/themeAugmentation";
import type {} from "@mui/lab/themeAugmentation";

import { AppColors, AppPalette, CustomPalette } from "./theme.model";

export { createTheme, ThemeProvider };

declare module "@mui/material/styles" {
  interface Theme {
    appColors: AppColors;
    appPalette: AppPalette;
    dimensions: any;
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    appColors?: AppColors;
    appPalette?: AppPalette;
    dimensions?: any;
  }
}

export type Theme = CustomPalette & MaterialTheme;
export { AppRouterCacheProvider } from "@mui/material-nextjs/v15-appRouter";

export const useTheme = () => useThemeReact() as Theme;
export type {} from "@mui/x-data-grid/themeAugmentation";
export type {} from "@mui/x-date-pickers-pro/themeAugmentation";
export type {} from "@mui/lab/themeAugmentation";
